import React from "react";

import ProvidersSlide from "../../components/providers-slide";
import GeneralStats from "../../components/debit-table/casino-debit-stats";
import SearchResults from "../casino-group/search-results";
import MiniSlider from "../homepage/mini-slider";
import {useSelector} from "react-redux";
import LiveCasinoLobbyGroups from "./group";

const LiveCasinoPage = () => {
    const {agent} = useSelector(state => state.globalReducer)

    return (
        <>
            <div className="section section--first">
                <MiniSlider page={'live-casino'}/>
            </div>


            {
                !agent?.isMobile &&
                <div className="section section--first">
                    <div className="container">
                        <SearchResults type={'live-casino'}/>
                    </div>
                </div>
            }


            <LiveCasinoLobbyGroups/>


            <GeneralStats/>

            <ProvidersSlide type={'live-casino'}/>

        </>

    )

}

export default LiveCasinoPage
